module.exports = require('./helpers/bundle-url').getBundleURL('ciDtH') + "carrierLogisticsBackgroundImg.412c8757.png";